import { q, qq } from "bobjoll/ts/library/dom";
import { qi } from "bobjoll/ts/library/gr/dom.q";
import Alert from 'BobjollAlert';
import language from 'Library/language';
import User from 'Library/gr/user';
import Validation from 'Partials/validation';

const alert = new Alert({
    position: 'bottom-center'
});

class Comment {
    public static async eventHandlerSubmit(this: HTMLFormElement, e: Event) {
        e.preventDefault();
        e.stopPropagation();

        if (await User.isLogged(true)) {
            const author = qi('input[name="author"]', this);
            const avatar = qi('input[name="gr_avatar', this);
            const email = qi('input[name="email"]', this);
            const id = qi('input[name="gr_id', this);

            if (author && avatar && email && id && gr.user) {
                const grAuthor = gr.user.real_name || gr.user.login;
                const grAvatar = gr.user.avatar;
                const grEmail = gr.user.email;
                const grId = gr.user.id.toString();

                author.value = grAuthor;
                avatar.value = grAvatar;
                email.value = grEmail;
                id.value = grId;
            }

            Validation(this);
        }
    }
}

(qq('.comment-form form') as HTMLFormElement[]).forEach(form => form.addEventListener('submit', Comment.eventHandlerSubmit));

if (window.location.hash) {
    const comment = q(window.location.hash);
    
    if (!comment) {
        alert.new(language('Your comment was sent succesfully, it is waiting for aproval.'), 'warning', true);
    }
}